<template>
    <button
        v-tippy="t('editorInsertTable')"
        :class="[buttonState(editor.can().insertTable()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().insertTable()"
        @click="
            editor
                .chain()
                .focus()
                .insertTable({
                    rows: 3,
                    cols: 3,
                    withHeaderRow: true,
                })
                .run()
        "
    >
        <MdiTable class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTable from 'materialdesignicons-vue3/icons/MdiTable.js';

    defineExpose({
        name: 'AddTableButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
